import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        if ($("a, button, input").length) {
            if (globals.debug) console.log("component-tab-focus initialized");

            $("body").on("keyup", "a, button, input", function (_e) {
                if (_e.which == 9) {
                    $(".tab-focus").removeClass("tab-focus on");
                    $(_e.target).addClass("tab-focus on");
                }
            });
        }
    });
})();

export default component;
